import { render, staticRenderFns } from "./ResidentSettings.vue?vue&type=template&id=d1d92370&scoped=true"
import script from "./ResidentSettings.ts?vue&type=script&lang=js&external"
export * from "./ResidentSettings.ts?vue&type=script&lang=js&external"
import style0 from "./ResidentSettings.scss?vue&type=style&index=0&id=d1d92370&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d92370",
  null
  
)

export default component.exports